'use client';
import { cn } from '@/lib/utils';
import Image from 'next/image';
const list = [
  {
    title: 'Step 1. Clean the boots with water and a brush.',
    content: [
      'Natural rubber and neoprene upper are very durable, feel free to use the brush to clean with a spray of water or scrubbing with soap and cold water gentlely.',
    ],
  },
  {
    title: 'Step 2. Dry the boots, naturally.',
    content: [
      'Keep your boots in a dry and ventilated place, away from direct sunlight and away from any heat source. Let the boots air dry. ',
      'If the boots get wet, dry the lining thoroughly before starting to use them again. Crumpled newspaper can be used to help with the drying.',
    ],
  },
  {
    title: 'Step 3. Store your boots in dry, cool place.',
    content: [
      'Store your cleaned boots away directly from the sunlight. Put them in dry and cool place, away from other heat sources. ',
      'If you want, you can also nourish the boots with some wax polish to add extra protection to your boots.',
    ],
  },
];
const CareGuidePage = (): JSX.Element => {
  return (
    <div className='w-full'>
      {list.map((item, index) => (
        <div
          key={index}
          className={cn(
            'mb-[40px] flex flex-col items-center justify-between gap-[20px] lg_mb-[20px] lg_flex-row lg_gap-[50px]',
            index != 1 && 'lg_flex-row-reverse',
          )}
        >
          <Image
            className='w-full lg_h-[260px] lg_w-[380px]'
            src={`/careGuide/rubber${index + 1}.png`}
            alt='step'
            width={300}
            height={300}
          />
          <div className='flex flex-col items-start lg_h-[260px] lg_pt-[40px]'>
            <h3 className='mb-[10px] font-roboto-medium text-[18px] font-medium leading-[22px] lg_mb-[20px] lg_text-[16px]'>
              {item.title}
            </h3>
            {item.content.map((content, i) => (
              <p
                key={i}
                className='mb-[10px] font-roboto-light text-[16px] font-light leading-[26px] lg_mb-[20px]'
              >
                {content}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CareGuidePage;
